<script setup>
import { computed } from 'vue';
import { readBootstrap } from '../../shared/bootstrap.js';
import CategoryNavItem from './components/CategoryNavItem.vue';
import { columnLeftTheme } from './column-left.config.js';
import { normalizeColumnLeftBoot } from './helpers/column-left-data.js';

const boot = readBootstrap(
  typeof document !== 'undefined' ? document.getElementById('vsb-vue-column-left') : null,
  'vsb-column-left-bootstrap'
);

const page = computed(() => normalizeColumnLeftBoot(boot));

const active = computed(() => ({
  activeCategoryId: page.value.activeCategoryId,
  activeChildId: page.value.activeChildId,
  activeChildId2: page.value.activeChildId2
}));

const themeVars = computed(() => ({
  '--vsb-col-bg': columnLeftTheme.bg,
  '--vsb-col-border': columnLeftTheme.border,
  '--vsb-col-title': columnLeftTheme.titleColor,
  '--vsb-col-link': columnLeftTheme.linkColor,
  '--vsb-col-link-active': columnLeftTheme.linkActiveColor,
  '--vsb-col-link-active-bg': columnLeftTheme.linkActiveBg,
  '--vsb-col-child-border': columnLeftTheme.childBorder
}));
</script>

<template>
  <nav
    v-if="page.categories.length"
    id="column-left"
    class="vsb-column-left"
    :style="themeVars"
    aria-label="Categorieën"
  >
    <div class="vsb-column-left__box">
      <h2 class="vsb-column-left__title">{{ page.title }}</h2>
      <ul class="vsb-col-nav">
        <CategoryNavItem
          v-for="cat in page.categories"
          :key="cat.categoryId"
          :category="cat"
          :active="active"
        />
      </ul>
    </div>
  </nav>
</template>

<style scoped>
.vsb-column-left {
  flex: 0 0 240px;
  max-width: 240px;
  min-width: 200px;
}

.vsb-column-left__box {
  background: var(--vsb-col-bg, #fff);
  border: 1px solid var(--vsb-col-border, #e8ecf0);
  border-radius: 10px;
  padding: 1rem 0.75rem;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
}

.vsb-column-left__title {
  margin: 0 0 0.75rem;
  padding: 0 0.35rem 0.5rem;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--vsb-col-title, #0b3d91);
  border-bottom: 2px solid var(--vsb-col-border, #e8ecf0);
}

.vsb-col-nav {
  list-style: none;
  margin: 0;
  padding: 0;
}

@media (max-width: 768px) {
  .vsb-column-left {
    display: none;
  }
}
</style>
